const productPageAccordions = () => {
  if (!document.querySelector('.template-product')) return

  const productInfo = document.querySelector('.product-information')
  if (!productInfo) return

  const accordions = productInfo.querySelectorAll('.product__accordion details')
  accordions.forEach(accordion => {
    accordion.addEventListener('click', () => {
      const id = accordion.id
      const activeAccordions = productInfo.querySelectorAll('.product__accordion details[open]')
      activeAccordions.forEach(activeAccordion => {
        if (activeAccordion.id !== id) {
          activeAccordion.removeAttribute('open')
        }
      })
    })
  })
}
productPageAccordions()
